import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'
import { SettingPageCustomTimeRangeFragment } from 'generated/resources/graphql'

import Content from './Content'

export interface CellProps {
  timeRanges: SettingPageCustomTimeRangeFragment[]
  dayType?: AttendanceCustomTimeRangeDayEnum
  showNotDefined: boolean
  base?: boolean
  isSpecificDateMode?: boolean
}

const Cell = ({
  dayType,
  timeRanges,
  showNotDefined,
  base = false,
  isSpecificDateMode,
}: CellProps) => {
  const [hover, setHover] = React.useState<boolean>(false)
  const onMouseEnter = () => setHover(true)
  const onMouseLeave = () => setHover(false)
  const showTimeBlock = !!timeRanges.length
  const showAddBlock = !showTimeBlock && hover && showNotDefined
  const height = showAddBlock ? 'full' : undefined
  const paddingTop = base ? 's12' : 's0'

  return (
    <Box
      height={height}
      cursor="pointer"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      paddingTop={paddingTop}
      minHeight="s140"
      width="s200"
    >
      <Content
        timeRanges={timeRanges}
        dayType={dayType}
        hover={hover}
        base={base}
        showNotDefined={showNotDefined}
        isSpecificDateMode={isSpecificDateMode}
      />
    </Box>
  )
}

export default Cell
